import styled, { css } from 'styled-components';

const StyledNavLinkBase = css`
  color: ${p => p.theme.colors.black};
  padding: 6px 0;
  text-decoration: none;
  width: 100%;
`;

const StyledNavLinkLi = styled.li`
  cursor: pointer;
  display: flex;
  line-height: ${p => p.theme.lineHeight.controls};
  a {
    text-decoration: none;
    color: ${p => (p.isActive ? p.theme.colors.green400 : p.theme.colors.black)};
    font-weight: ${p => (p.isActive ? p.theme.fontWeight.heavy : p.theme.fontWeight.normal)};
  }
`;

export { StyledNavLinkBase, StyledNavLinkLi };



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/nav/nav_link_styles.jsx